import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollFieldOptionSchema } from './shapes';

export const AddPollOptionBodySchema = z.object({ label: z.string().trim().min(1).max(200) });

export const addPollOption = defineEndpoint({
  method: 'POST',
  path: '/v1/polls/:pollId/fields/:fieldId/options',
  params: z.object({ pollId: z.string().uuid(), fieldId: z.string().uuid() }),
  query: z.object({}),
  body: AddPollOptionBodySchema,
  response: z.object({ data: PollFieldOptionSchema }),
  successStatus: 201,
});
